import React from 'react';
import PropTypes from 'prop-types';
import { TOUCHED_FLAG_SUFFIX } from './constants';
import CustomNumeral from '../../shared/customNumeral.component';
import { YES_FLAG } from '../../shared/constants';
import { getCellElementId } from './utils';

export const DefaultValueRenderer = ({ value }) => typeof value === 'number'
  ? <CustomNumeral>{value}</CustomNumeral>
  : (value || null);

DefaultValueRenderer.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export const CustomValueRenderer = ({ value, cellFormat }) => <CustomNumeral type={cellFormat}>{value}</CustomNumeral>;

CustomValueRenderer.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  cellFormat: PropTypes.string.isRequired,
};

const getTouchedFlag = ({ prefix, report, fieldDefinition }) => {
  const from = typeof fieldDefinition.from === 'object'
    ? fieldDefinition.from[report.reportName]
    : fieldDefinition.from;

  if (!from) {
    return null;
  }

  return report[`${prefix}${from}${TOUCHED_FLAG_SUFFIX}`] === YES_FLAG;
};

export const ReportCellRendererFactory = ({
  report,
  prefix,
}) => {
  const ReportCellRenderer = ({ value, node, column, data: fieldDefinition }) => {
    const { cellFormat } = fieldDefinition ? fieldDefinition : {};

    const touchedFlag = getTouchedFlag({
      prefix,
      report,
      fieldDefinition,
    });

    return (
      <span data-tip="" id={getCellElementId(column.colId, node.rowIndex)}>
        {cellFormat
          ? CustomValueRenderer({ value, cellFormat })
          : DefaultValueRenderer({ value })
        }
        {touchedFlag ? <div className="with-indicator" /> : null}
      </span>
    );
  };

  ReportCellRenderer.propTypes = {
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
    node: PropTypes.shape({
      rowIndex: PropTypes.number,
    }),
    column: PropTypes.shape({
      colId: PropTypes.string,
    }),
    data: PropTypes.shape({
      cellFormat: PropTypes.string,
    }),
  };

  return ReportCellRenderer;
};
